import React, { useState, useEffect } from 'react';
//import { Menu, X, Phone, Mail, MapPin, Clock, Calendar, ChevronDown, Globe, Landmark, Archive, Link as LinkIcon, HandCoins, FileText, Image as ImageIcon } from 'lucide-react';
import { Menu, X, Phone, Mail, MapPin, Clock, Calendar, Globe, Landmark, Archive, Link as LinkIcon, HandCoins, FileText, Image as ImageIcon } from 'lucide-react';
import logo from './logo.png'; // adjust path to your image location

const MuruganTempleWebsite = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [language, setLanguage] = useState('en');
  const [isScrolled, setIsScrolled] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Gallery images from the provided URLs (duplicates removed)
  const galleryImages = [
    ...new Set([
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/10410648_855422997809457_8945592502037423403_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/1455066_855420461143044_6191643826399384686_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/10305327_854950301190060_5768170348471823055_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/10369859_855426471142443_4333441426630637315_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/10730988_855426414475782_5667410601299656107_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/20141029_2143451.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/20141029_2143551.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/10649811_850477231637367_2719649270489697042_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/10271600_850477074970716_654400441029893989_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/10636274_850477138304043_8769632360355638585_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/10731017_850477184970705_709441520931524799_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/1380448_850477158304041_442446754521498332_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/10590407_850476988304058_9012852478026535970_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/1233992_850477034970720_6428698511128274151_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/1381325_850481968303560_2075283579708700366_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/1527093_850480951636995_3102902485732748375_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/1932416_850480971636993_7872602496311458371_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/1013522_850480691637021_801792642328265060_n1.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2014/11/1457623_854950494523374_5487297031945671203_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2014/11/10351103_854951607856596_7370366556937373643_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2014/11/10639687_849947305023693_119242315529140291_n1.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2014/11/10805630_854949971190093_2063467897479268511_n.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/DSC01358.jpg',
      'http://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/image.jpg'
    ])
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      
      const sections = ['home', 'about', 'services', 'calendar', 'gallery', 'donations', 'archive', 'links', 'contact'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ta' : 'en');
  };

  const translations = {
    en: {
      nav: {
        home: 'Home',
        about: 'About',
        services: 'Services',
        calendar: 'Calendar',
        gallery: 'Gallery',
        donations: 'Donations',
        archive: 'Archive',
        links: 'Links',
        contact: 'Contact'
      },
      hero: {
        title: 'Murugan Temple Limburg',
        subtitle: 'Vereniging Murugan Temple Limburg',
        description: 'A sacred place of worship and community for devotees in the Limburg region',
        cta: 'View Calendar'
      },
      about: {
        title: 'About Our Temple',
        subtitle: 'A Sacred Space for Spiritual Growth',
        text1: 'The Murugan Temple Limburg serves as a spiritual and cultural center for the Tamil Hindu community in the Limburg region of the Netherlands. Our temple is dedicated to Lord Murugan, the deity of wisdom, courage, and divine grace.',
        text2: 'We provide a welcoming space for devotees to practice their faith, celebrate festivals, and strengthen community bonds through religious and cultural activities.',
        mission: 'Our Mission',
        missionText: 'To preserve and promote Hindu dharma, provide spiritual guidance, and serve as a cultural hub for our community while fostering harmony and understanding.'
      },
      services: {
        title: 'Our Services',
        subtitle: 'Temple Poojas and Religious Services',
        tuesdayInfo: 'When there is no special pooja on a Tuesday, the Temple will be open from 18:00h onwards and there will a pooja/prayer from 19:00h to 20:00h.',
        daily: {
          title: 'Poojas',
          desc: 'Regular evening poojas performed by our dedicated priests'
        },
        friday: {
          title: 'Friday Special Poojas',
          desc: 'Special prayers and offerings every Friday - check our calendar for timings'
        },
        special: {
          title: 'Special Event Poojas',
          desc: 'Customized poojas for festivals, personal events, and special occasions'
        },
        contact: 'For pooja arrangements and special events, please contact our temple committee members.',
        shivaratri: 'Maha Shivaratri',
        shivaratriDesc: 'Special celebrations and prayers during Maha Shivaratri festival',
        thirupalli: 'Thirupalliyezhuchi',
        thirupalliDesc: 'Sacred awakening ceremony for Lord Shiva',
        kolaru: 'Kolaru Pathigam',
        kolaruDesc: 'Special prayers for planetary relief and blessings',
        sivapuranam: 'Sivapuranam',
        sivapuranamDesc: 'Recitation of the sacred hymns of Sivapuranam',
        panguni: 'Panguni Uthiram',
        panguniDesc: 'Celebration of the Panguni Uthiram festival',
        vaighaasi: 'Vaighaasi Visagam',
        vaighaasiDesc: "Observance of Vaighaasi Visagam, Lord Murugan's birth star",
        viewDetails: 'View PDF / Image'
      },
      calendar: {
        title: 'Temple Calendar',
        //subtitle: 'Tuesday, Friday & Special Pooja Details',
        announcement: 'Tuesday, Friday and Special Pooja details are published',
        view: 'View Full Calendar'
      },
      gallery: {
        title: 'Temple Gallery',
        subtitle: 'Glimpses of Our Temple and Celebrations',
      },
      donations: {
        title: 'Donations & Support',
        subtitle: 'Your contributions help maintain and grow our sacred space',
        bankTitle: 'Bank Details',
        bankDesc: 'You can make a donation directly to our bank account.',
        kvk: 'KVK reg. nr'
      },
      archive: {
        title: 'Archive',
        subtitle: 'Information on past events and initiatives',
        buildingFund: 'Building Fund Collection',
        buildingFundDesc: 'Information regarding the building fund collection drives. Thank you for your past and future support.',
        doc1: 'Download PDF 1',
        doc2: 'Download PDF 2',
        pastEvents: 'Past Special Events',
        pastEventsDesc: 'Details and galleries from previous years special events and celebrations will be archived here.'
      },
      links: {
        title: 'Useful Links',
        subtitle: 'Resources for devotees',
        muruganWiki: 'About Lord Murugan',
        thevaaram: 'Thevaaram.org',
        hinduTemple: 'Hindu Temple Netherlands'
      },
      contact: {
        title: 'Contact Us',
        subtitle: 'Visit Us or Get in Touch',
        address: 'Address',
        phone: 'Phone Numbers',
        email: 'Email',
        priests: 'Temple Priests',
        arrangements: 'For Pooja Arrangements',
        formTitle: 'Send Us a Message',
        namePlaceholder: 'Your Name',
        emailPlaceholder: 'Your Email',
        messagePlaceholder: 'Your Message',
        submit: 'Send Message',
        required: 'Required field'
      },
      footer: {
        about: 'About Temple',
        aboutText: 'Murugan Temple Limburg serves the Hindu community in the Limburg region with devotion and dedication.',
        quick: 'Quick Links',
        followUs: 'Visit Us',
        rights: 'All rights reserved.',
        address: 'Litscherveldweg 15, 6413 BA Heerlen, The Netherlands'
      }
    },
    ta: {
      nav: {
        home: 'முகப்பு',
        about: 'பற்றி',
        services: 'சேவைகள்',
        calendar: 'நாட்காட்டி',
        gallery: 'படத்தொகுப்பு',
        donations: 'நன்கொடைகள்',
        archive: 'காப்பகம்',
        links: 'இணைப்புகள்',
        contact: 'தொடர்பு'
      },
      hero: {
        title: 'முருகன் கோவில் லிம்பர்க்',
        subtitle: 'சங்கம் முருகன் கோவில் லிம்பர்க்',
        description: 'லிம்பர்க் பிராந்தியத்தில் பக்தர்களுக்கான ஒரு புனித வழிபாட்டு மற்றும் சமூக இடம்',
        cta: 'நாட்காட்டியைப் பார்க்கவும்'
      },
      about: {
        title: 'எங்கள் கோவில் பற்றி',
        subtitle: 'ஆன்மீக வளர்ச்சிக்கான புனித இடம்',
        text1: 'முருகன் கோவில் லிம்பர்க் நெதர்லாந்தின் லிம்பர்க் பிராந்தியத்தில் தமிழ் இந்து சமூகத்திற்கு ஒரு ஆன்மீக மற்றும் கலாச்சார மையமாக செயல்படுகிறது. எங்கள் கோவில் ஞானம், தைரியம் மற்றும் தெய்வீக அருளின் தெய்வமான முருகப் பெருமானுக்கு அர்ப்பணிக்கப்பட்டுள்ளது.',
        text2: 'பக்தர்கள் தங்கள் நம்பிக்கையை கடைப்பிடிக்கவும், திருவிழாக்களை கொண்டாடவும், மத மற்றும் கலாச்சார நடவடிக்கைகள் மூலம் சமூக பிணைப்புகளை வலுப்படுத்தவும் வரவேற்கும் இடத்தை நாங்கள் வழங்குகிறோம்.',
        mission: 'எங்கள் நோக்கம்',
        missionText: 'இந்து தர்மத்தை பாதுகாத்து மேம்படுத்துதல், ஆன்மீக வழிகாட்டுதலை வழங்குதல், மற்றும் நல்லிணக்கத்தையும் புரிதலையும் வளர்க்கும் அதே வேளையில் எங்கள் சமூகத்திற்கான கலாச்சார மையமாக செயல்படுதல்.'
      },
      services: {
        title: 'எங்கள் சேவைகள்',
        subtitle: 'கோவில் பூஜைகள் மற்றும் மத சேவைகள்',
        tuesdayInfo: 'விசேட பூஜைகள் இல்லாத செவ்வாய்க்கிழமைகளில் ஆலயம் 18:00 மணிக்கு திறக்கப்பட்டு 19:00 தொடக்கம் 20:00 வரை பூஜை நடைபெறும்.',
        daily: {
          title: 'பூஜைகள்',
          desc: 'எங்கள் அர்ப்பணிப்புள்ள குருக்கள் மூலம் வழக்கமான மாலை பூஜைகள்'
        },
        friday: {
          title: 'வெள்ளிக்கிழமை சிறப்பு பூஜைகள்',
          desc: 'ஒவ்வொரு வெள்ளிக்கிழமையும் சிறப்பு பிரார்த்தனைகள் - நேரங்களுக்கு எங்கள் நாட்காட்டியைப் பார்க்கவும்'
        },
        special: {
          title: 'சிறப்பு நிகழ்வு பூஜைகள்',
          desc: 'திருவிழாக்கள், தனிப்பட்ட நிகழ்வுகள் மற்றும் சிறப்பு சந்தர்ப்பங்களுக்கான தனிப்பயனாக்கப்பட்ட பூஜைகள்'
        },
        contact: 'பூஜை ஏற்பாடுகள் மற்றும் சிறப்பு நிகழ்வுகளுக்கு, தயவுசெய்து எங்கள் கோவில் குழு உறுப்பினர்களைத் தொடர்பு கொள்ளவும்.',
        shivaratri: 'மஹா சிவராத்திரி',
        shivaratriDesc: 'மஹா சிவராத்திரி விழாவின் போது சிறப்பு கொண்டாட்டங்கள் மற்றும் பிரார்த்தனைகள்',
        thirupalli: 'திருப்பள்ளியெழுச்சி',
        thirupalliDesc: 'சிவபெருமானுக்கான புனித எழுப்புதல் சடங்கு',
        kolaru: 'கோளறு பதிகம்',
        kolaruDesc: 'கிரக நிவாரணம் மற்றும் ஆசீர்வாதங்களுக்கான சிறப்பு பிரார்த்தனைகள்',
        sivapuranam: 'சிவபுராணம்',
        sivapuranamDesc: 'புனிதமான சிவபுராணப் பாடல்களின் பாராயணம்',
        panguni: 'பங்குனி உத்திரம்',
        panguniDesc: 'பங்குனி உத்திரம் திருவிழா கொண்டாட்டம்',
        vaighaasi: 'வைகாசி விசாகம்',
        vaighaasiDesc: 'முருகப்பெருமானின் பிறந்த நட்சத்திரமான வைகாசி விசாகம் அனுசரிப்பு',
        viewDetails: 'PDF / படம் பார்க்க'
      },
      calendar: {
        title: 'கோவில் நாட்காட்டி',
        //subtitle: 'செவ்வாய், வெள்ளி மற்றும் சிறப்பு பூஜை விபரங்கள்',
        announcement: 'செவ்வாய், வெள்ளி மற்றும் சிறப்பு பூஜை விபரங்கள் வெளியிடப்பட்டுள்ளன',
        view: 'முழு நாட்காட்டியைப் பார்க்கவும்'
      },
      gallery: {
        title: 'கோவில் படத்தொகுப்பு',
        subtitle: 'எங்கள் கோவில் மற்றும் கொண்டாட்டங்களின் காட்சிகள்',
      },
      donations: {
        title: 'நன்கொடைகள் மற்றும் ஆதரவு',
        subtitle: 'உங்கள் பங்களிப்புகள் எங்கள் புனித இடத்தை பராமரிக்கவும் வளர்க்கவும் உதவுகின்றன',
        bankTitle: 'வங்கி விபரங்கள்',
        bankDesc: 'எங்கள் வங்கி கணக்கிற்கு நேரடியாக நன்கொடை அளிக்கலாம்.',
        kvk: 'KVK பதிவு எண்'
      },
      archive: {
        title: 'காப்பகம்',
        subtitle: 'கடந்த நிகழ்வுகள் மற்றும் முயற்சிகள் பற்றிய தகவல்கள்',
        buildingFund: 'கட்டிட நிதி வசூல்',
        buildingFundDesc: 'கட்டிட நிதி வசூல் முயற்சிகள் தொடர்பான தகவல்கள். உங்கள் கடந்த கால மற்றும் எதிர்கால ஆதரவுக்கு நன்றி.',
        doc1: 'PDF 1 பதிவிறக்கம்',
        doc2: 'PDF 2 பதிவிறக்கம்',
        pastEvents: 'கடந்த சிறப்பு நிகழ்வுகள்',
        pastEventsDesc: 'முந்தைய ஆண்டுகளின் சிறப்பு நிகழ்வுகள் மற்றும் கொண்டாட்டங்களின் விவரங்கள் மற்றும் படங்கள் இங்கே காப்பகப்படுத்தப்படும்.'
      },
      links: {
        title: 'பயனுள்ள இணைப்புகள்',
        subtitle: 'பக்தர்களுக்கான ஆதாரங்கள்',
        muruganWiki: 'முருகப்பெருமான் பற்றி',
        thevaaram: 'தேவாரம்.org',
        hinduTemple: 'இந்து கோவில் நெதர்லாந்து'
      },
      contact: {
        title: 'தொடர்பு கொள்ள',
        subtitle: 'எங்களை பார்வையிடுங்கள் அல்லது தொடர்பு கொள்ளுங்கள்',
        address: 'முகவரி',
        phone: 'தொலைபேசி எண்கள்',
        email: 'மின்னஞ்சல்',
        priests: 'கோவில் குருக்கள்',
        arrangements: 'பூஜை ஏற்பாடுகளுக்கு',
        formTitle: 'எங்களுக்கு ஒரு செய்தி அனுப்புங்கள்',
        namePlaceholder: 'உங்கள் பெயர்',
        emailPlaceholder: 'உங்கள் மின்னஞ்சல்',
        messagePlaceholder: 'உங்கள் செய்தி',
        submit: 'செய்தி அனுப்பு',
        required: 'தேவையான புலம்'
      },
      footer: {
        about: 'கோவில் பற்றி',
        aboutText: 'முருகன் கோவில் லிம்பர்க் பக்தி மற்றும் அர்ப்பணிப்புடன் லிம்பர்க் பிராந்தியத்தில் இந்து சமூகத்திற்கு சேவை செய்கிறது.',
        quick: 'விரைவு இணைப்புகள்',
        followUs: 'எங்களை பார்வையிடுங்கள்',
        rights: 'அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.',
        address: 'Litscherveldweg 15, 6413 BA Heerlen, The Netherlands'
      }
    }
  };

  const t = translations[language];

  const specialEvents = [
    { title: t.services.shivaratri, desc: t.services.shivaratriDesc, link: 'https://www.murugantemplelimburg.nl/wp-content/uploads/2011/02/image0011.png' },
    { title: t.services.thirupalli, desc: t.services.thirupalliDesc, link: 'https://www.murugantemplelimburg.nl/wp-content/uploads/2011/02/image0021.png' },
    { title: t.services.kolaru, desc: t.services.kolaruDesc, link: 'https://www.murugantemplelimburg.nl/wp-content/uploads/2011/02/image0041.png' },
    { title: t.services.sivapuranam, desc: t.services.sivapuranamDesc, link: 'https://www.murugantemplelimburg.nl/wp-content/uploads/2011/02/image0031.png' },
    { title: t.services.panguni, desc: t.services.panguniDesc, link: 'https://www.murugantemplelimburg.nl/wp-content/uploads/2011/03/panguni_uthiram1.png' },
    { title: t.services.vaighaasi, desc: t.services.vaighaasiDesc, link: 'https://www.murugantemplelimburg.nl/wp-content/uploads/2011/05/Vaigaasi-Visagam.png' }
  ];

  const navItems = [
    { id: 'home', label: t.nav.home },
    { id: 'about', label: t.nav.about },
    { id: 'services', label: t.nav.services },
    { id: 'calendar', label: t.nav.calendar },
    { id: 'gallery', label: t.nav.gallery },
    { id: 'donations', label: t.nav.donations },
    { id: 'archive', label: t.nav.archive },
    { id: 'links', label: t.nav.links },
    { id: 'contact', label: t.nav.contact }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            {/* <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('home')}>
              <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
                OM
              </div>
              <div>
                <div className="text-xl font-bold text-gray-900">
                  {language === 'en' ? 'Murugan Temple' : 'முருகன் கோவில்'}
                </div>
                <div className="text-sm text-gray-600">Limburg</div>
              </div>
            </div> */}
            <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src={logo} 
              alt="Murugan Temple Logo" 
              className="w-12 h-12 object-contain"
            />
            <div>
              <div className="text-xl font-bold text-gray-900">
                {language === 'en' ? 'Murugan Temple' : 'முருகன் கோவில்'}
              </div>
              <div className="text-sm text-gray-600">Limburg | லிம்பர்க்</div>
            </div>
          </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-6">
              {navItems.map(item => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`text-sm font-medium transition-colors ${
                    activeSection === item.id
                      ? 'text-orange-600'
                      : 'text-gray-700 hover:text-orange-600'
                  }`}
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={toggleLanguage}
                className="flex items-center space-x-2 px-3 py-2 bg-orange-50 text-orange-600 rounded-lg hover:bg-orange-100 transition-colors"
              >
                <Globe className="w-4 h-4" />
                <span className="text-sm font-medium">{language === 'en' ? 'தமிழ்' : 'English'}</span>
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden flex items-center space-x-4">
              <button
                onClick={toggleLanguage}
                className="p-2 text-orange-600"
              >
                <Globe className="w-5 h-5" />
              </button>
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="p-2 text-gray-700"
              >
                {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200">
            <div className="px-4 py-4 space-y-3">
              {navItems.map(item => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`block w-full text-left px-4 py-2 rounded-lg transition-colors ${
                    activeSection === item.id
                      ? 'bg-orange-50 text-orange-600'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="home" className="pt-20 min-h-screen flex items-center bg-gradient-to-br from-orange-50 via-red-50 to-yellow-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src={logo} 
              alt="Murugan Temple Logo" 
              className="w-12 h-12 object-contain"/>
              <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-4">
                {t.hero.title}
              </h1>

              {/* <div>
                <div className="text-xl font-bold text-gray-900">
                  {language === 'en' ? 'Murugan Temple' : 'முருகன் கோவில்'}
                </div>
                <div className="text-sm text-gray-600">Limburg</div>
              </div> */}
          </div>
            {/* <div className="mb-8 flex justify-center">
              <div className="w-32 h-32 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center text-white shadow-2xl">
                <span className="text-5xl font-bold">OM</span>
              </div>
            </div> */}
            <p className="text-xl md:text-2xl text-gray-700 mb-4 font-medium">
              {t.hero.subtitle}
            </p>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              {t.hero.description}
            </p>
            <button
              onClick={() => scrollToSection('calendar')}
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-orange-500 to-red-600 text-white font-semibold rounded-full hover:shadow-xl transition-all transform hover:scale-105"
            >
              <Calendar className="w-5 h-5 mr-2" />
              {t.hero.cta}
            </button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t.about.title}
            </h2>
            <p className="text-xl text-gray-600">{t.about.subtitle}</p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Image Section */}
            <div>
              <img 
                src="https://www.murugantemplelimburg.nl/wp-content/uploads/2009/12/10425438_861182697233487_4852194672794862357_n.jpg"
                alt="Murugan Temple Limburg"
                className="w-full h-96 object-cover object-center rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300"
              />
            </div>

            {/* Text Content Section */}
            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                {t.about.text1}
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                {t.about.text2}
              </p>
              <div className="bg-orange-50 border-l-4 border-orange-500 p-6 rounded-r-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {t.about.mission}
                </h3>
                <p className="text-gray-700">
                  {t.about.missionText}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Services Section */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t.services.title}
            </h2>
            <p className="text-xl text-gray-600">{t.services.subtitle}</p>
          </div>
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg mb-12">
            <div className="flex items-start space-x-4">
                <Clock className="w-6 h-6 mt-1 text-blue-600 flex-shrink-0" />
                <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{language === 'en' ? 'Tuesday Pooja Information' : 'செவ்வாய் பூஜை தகவல்'}</h3>
                    <p className="text-gray-700">{t.services.tuesdayInfo}</p>
                </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {[
              { title: t.services.daily.title, desc: t.services.daily.desc, icon: '🔔' },
              { title: t.services.friday.title, desc: t.services.friday.desc, icon: '⭐' },
              { title: t.services.special.title, desc: t.services.special.desc, icon: '🎊' }
            ].map((service, idx) => (
              <div key={idx} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="text-5xl mb-4">{service.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-orange-500 to-red-600 rounded-xl p-8 text-white mb-12">
            <div className="flex items-start space-x-4">
              <Phone className="w-6 h-6 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-bold mb-2">{language === 'en' ? 'Contact for Arrangements' : 'ஏற்பாடுகளுக்கு தொடர்பு'}</h3>
                <p className="text-white/90">{t.services.contact}</p>
              </div>
            </div>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">{language === 'en' ? 'Special Events & Poojas' : 'சிறப்பு நிகழ்வுகள் மற்றும் பூஜைகள்'}</h3>
          <div className="grid md:grid-cols-3 gap-8">
            {specialEvents.map((event, idx) => (
              <div key={idx} className="bg-white rounded-xl p-6 border-2 border-orange-200 hover:border-orange-400 transition-colors flex flex-col justify-between">
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {event.title}
                  </h3>
                  <p className="text-gray-600 text-sm">
                    {event.desc}
                  </p>
                </div>
                <div className="mt-4">
                  <a 
                    href={event.link}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-sm font-medium text-orange-600 hover:text-orange-800"
                  >
                    <ImageIcon className="w-4 h-4 mr-2" />
                    {t.services.viewDetails}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Calendar Section */}
      <section id="calendar" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t.calendar.title}
            </h2>
            <p className="text-xl text-gray-600 mb-4">{t.calendar.subtitle}</p>
            <div className="inline-block bg-green-50 border border-green-200 rounded-lg px-6 py-3">
              <p className="text-green-800 font-medium">{t.calendar.announcement}</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 shadow-xl">
            <div className="aspect-video bg-white rounded-xl shadow-inner overflow-hidden">
              <iframe
                src="https://calendar.google.com/calendar/embed?src=fbb21dg4rprhavj352n8u46618%40group.calendar.google.com&ctz=Europe%2FAmsterdam"
                className="w-full h-full"
                frameBorder="0"
                scrolling="no"
                title="Temple Calendar"
              />
            </div>
            <div className="mt-6 text-center">
              <a
                href="https://calendar.google.com/calendar/embed?src=fbb21dg4rprhavj352n8u46618%40group.calendar.google.com&ctz=Europe%2FAmsterdam"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 transition-colors"
              >
                <Calendar className="w-5 h-5 mr-2" />
                {t.calendar.view}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t.gallery.title}
            </h2>
            <p className="text-xl text-gray-600">{t.gallery.subtitle}</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {galleryImages.map((imgUrl, idx) => (
              <div 
                key={idx} 
                className="aspect-square bg-gray-200 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer group"
                onClick={() => setSelectedImage(imgUrl)}
              >
                <img 
                  src={imgUrl} 
                  alt={`Temple Gallery ${idx + 1}`}
                  //alt={`Temple Gallery Image ${idx + 1}`} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Donations Section */}
      <section id="donations" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t.donations.title}
            </h2>
            <p className="text-xl text-gray-600">{t.donations.subtitle}</p>
          </div>
          <div className="max-w-2xl mx-auto bg-gradient-to-br from-green-50 to-teal-50 rounded-2xl p-8 shadow-lg">
            <div className="flex items-start space-x-5">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <HandCoins className="w-8 h-8 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{t.donations.bankTitle}</h3>
                <p className="text-gray-700 mb-4">{t.donations.bankDesc}</p>
                <div className="space-y-2 text-lg">
                    <p><span className="font-semibold">SNS Bank IBAN:</span> <span className="font-mono text-gray-800">NL77SNSB0946587337</span></p>
                    <p><span className="font-semibold">{t.donations.kvk}:</span> <span className="font-mono text-gray-800">40190345</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Archive Section */}
      <section id="archive" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t.archive.title}
            </h2>
            <p className="text-xl text-gray-600">{t.archive.subtitle}</p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="flex items-center space-x-4 mb-4">
                    <Landmark className="w-8 h-8 text-orange-600" />
                    <h3 className="text-xl font-bold text-gray-900">{t.archive.buildingFund}</h3>
                </div>
                <p className="text-gray-600">{t.archive.buildingFundDesc}</p>
                <div className="mt-4 pt-4 border-t border-gray-200 flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0">
                  <a href="https://www.murugantemplelimburg.nl/wp-content/uploads/2014/08/Collecte-brief-tamil.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm font-medium text-orange-600 hover:text-orange-800">
                    <FileText className="w-4 h-4 mr-2"/>
                    {t.archive.doc1}
                  </a>
                  <a href="https://www.murugantemplelimburg.nl/wp-content/uploads/2014/08/Collecte-brief-2.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm font-medium text-orange-600 hover:text-orange-800">
                    <FileText className="w-4 h-4 mr-2"/>
                    {t.archive.doc2}
                  </a>
                </div>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="flex items-center space-x-4 mb-4">
                    <Archive className="w-8 h-8 text-orange-600" />
                    <h3 className="text-xl font-bold text-gray-900">{t.archive.pastEvents}</h3>
                </div>
                <p className="text-gray-600">{t.archive.pastEventsDesc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Links Section */}
      <section id="links" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t.links.title}
            </h2>
            <p className="text-xl text-gray-600">{t.links.subtitle}</p>
          </div>
          <div className="max-w-md mx-auto space-y-4">
              <a href="http://en.wikipedia.org/wiki/Murugan" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-4 p-5 bg-gray-50 hover:bg-orange-50 rounded-lg transition-colors group">
                  <LinkIcon className="w-5 h-5 text-gray-500 group-hover:text-orange-600" />
                  <span className="font-medium text-gray-700 group-hover:text-orange-600">{t.links.muruganWiki}</span>
              </a>
              <a href="http://www.thevaaram.org/" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-4 p-5 bg-gray-50 hover:bg-orange-50 rounded-lg transition-colors group">
                  <LinkIcon className="w-5 h-5 text-gray-500 group-hover:text-orange-600" />
                  <span className="font-medium text-gray-700 group-hover:text-orange-600">{t.links.thevaaram}</span>
              </a>
              <a href="http://www.hindutemple.nl/index.php" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-4 p-5 bg-gray-50 hover:bg-orange-50 rounded-lg transition-colors group">
                  <LinkIcon className="w-5 h-5 text-gray-500 group-hover:text-orange-600" />
                  <span className="font-medium text-gray-700 group-hover:text-orange-600">{t.links.hinduTemple}</span>
              </a>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t.contact.title}
            </h2>
            <p className="text-xl text-gray-600">{t.contact.subtitle}</p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div className="space-y-8">
              {/* Address */}
              <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{t.contact.address}</h3>
                    <p className="text-gray-700">
                      Vereniging Murugan Temple Limburg<br />
                      Litscherveldweg 15<br />
                      6413 BA Heerlen<br />
                      The Netherlands
                    </p>
                  </div>
                </div>
              </div>

              {/* Phone Numbers */}
              <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">{t.contact.phone}</h3>
                    <div className="space-y-2 text-sm">
                      <p className="text-gray-700">
                        <span className="font-semibold">Temple:</span> <a href="tel:0031455740084" className="hover:text-orange-600">00 31 455740084</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Email */}
              <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{t.contact.email}</h3>
                    <a href="mailto:murugantempelheerlen@gmail.com" className="text-gray-700 hover:text-orange-600">
                      murugantempelheerlen@gmail.com
                    </a>
                  </div>
                </div>
              </div>

              {/* Priests */}
              <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-3">{t.contact.priests}</h3>
                <div className="space-y-2 text-sm text-gray-700">
                  <p>
                    <span className="font-semibold">Kirithara Kurukkal:</span><br />
                    <a href="tel:00491707062880" className="hover:text-orange-600">00 49 1707062880</a>
                  </p>
                  <p>
                    <span className="font-semibold">Uruthiranantha Kurukkal's son:</span><br />
                    Mobile: <a href="tel:0032494923444" className="hover:text-orange-600">00 32 494 923444</a><br />
                    Land: <a href="tel:003293299058" className="hover:text-orange-600">00 32 9329 9058</a><br />
                    Email: <a href="mailto:s.u.sarma@live.nl" className="hover:text-orange-600">s.u.sarma@live.nl</a>
                  </p>
                </div>
              </div>

              {/* For Pooja Arrangements */}
              <div className="bg-gradient-to-r from-orange-600 to-red-600 rounded-xl p-6 text-white">
                <h3 className="text-lg font-bold mb-3">{t.contact.arrangements}</h3>
                <div className="space-y-1 text-sm">
                  <p>Mr. P.Athavan: <a href="tel:0031616052920" className="hover:underline">00 31 616052920</a></p>
                  <p>Mr. P.Sribashkaran: <a href="tel:0031611330690" className="hover:underline">00 31 611330690</a></p>
                  <p>Mr. K.Sivakumaran: <a href="tel:0031640854656" className="hover:underline">00 31 640854656</a></p>
                  <p>Mr. P.Ravithasan: <a href="tel:0031617764531" className="hover:underline">00 31 617764531</a></p>
                  <p>Mr. S.Vivekananthan: <a href="tel:0031633051040" className="hover:underline">00 31 633051040</a></p>
                  <p>S.Uthayanan: <a href="tel:00491511525293" className="hover:underline">00 49 15115252933</a></p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">{t.contact.formTitle}</h3>
              <form className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t.contact.namePlaceholder} *
                  </label>
                  <input
                    type="text"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none"
                    placeholder={t.contact.namePlaceholder}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t.contact.emailPlaceholder} *
                  </label>
                  <input
                    type="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none"
                    placeholder={t.contact.emailPlaceholder}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t.contact.messagePlaceholder} *
                  </label>
                  <textarea
                    required
                    rows={6}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none resize-none"
                    placeholder={t.contact.messagePlaceholder}
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white font-semibold py-4 rounded-lg hover:shadow-xl transition-all transform hover:scale-105"
                >
                  {t.contact.submit}
                </button>
              </form>
            </div>
          </div>

          {/* Google Maps */}
          <div className="mt-12 rounded-xl overflow-hidden shadow-2xl">
            {/* <iframe
              src="
              https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2520.16569113878!2d5.990262815745207!3d50.88091897953696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c0a359577ebc8d%3A0x286f529f79612a2a!2sLitscherveldweg%2015%2C%206413%20BA%20Heerlen%2C%20Netherlands!5e0!3m2!1sen!2sde!4v1678886454321!5m2!1sen!2sde"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Temple Location"
            /> */}
            <iframe title="Temple Location Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2515.5538135988736!2d5.956287839698067!2d50.91347155403727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4171874171eeb511%3A0x47eddff88bd92d22!2sVereniging%20Murugan%20Temple%20Limburg!5e0!3m2!1sen!2sde!4v1759855723908!5m2!1sen!2sde"
            width="1200" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* About */}
                { <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('home')}>
                <img 
                  src={logo} 
                  alt="Murugan Temple Logo" 
                  className="w-12 h-12 object-contain"/>
                <div>
                <div className="text-xl font-bold">
                  {language === 'en' ? 'Murugan Temple' : 'முருகன் கோவில்'}
                </div>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                {t.footer.aboutText}
              </p>
            </div> }

            {/* <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src={logo} 
              alt="Murugan Temple Logo" 
              className="w-12 h-12 object-contain"
            />
            <div>
              <div className="text-xl font-bold text-gray-900">
                {language === 'en' ? 'Murugan Temple' : 'முருகன் கோவில்'}
              </div>
              <div className="text-sm text-gray-600">Limburg | லிம்பர்க்</div>
            </div>
          </div>  */}

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-bold mb-4">{t.footer.quick}</h3>
              {/* Use a 2-column grid instead of a single list */}
              <div className="grid grid-cols-2 gap-x-8 gap-y-2">
                {navItems.map(item => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className="text-gray-400 hover:text-orange-400 transition-colors text-sm text-left"
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-bold mb-4">{t.footer.followUs}</h3>
              <div className="space-y-3 text-sm text-gray-400">
                <div className="flex items-start space-x-2">
                  <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                  <span>{t.footer.address}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Phone className="w-4 h-4 flex-shrink-0" />
                  <a href="tel:0031455740084" className="hover:text-orange-400">00 31 455740084</a>
                </div>
                <div className="flex items-center space-x-2">
                  <Mail className="w-4 h-4 flex-shrink-0" />
                  <a href="mailto:murugantempelheerlen@gmail.com" className="hover:text-orange-400">
                    murugantempelheerlen@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Vereniging Murugan Temple Limburg. {t.footer.rights}
            </p>
          </div>
        </div>
      </footer>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/80 z-[100] flex items-center justify-center p-4 cursor-zoom-out" 
          onClick={() => setSelectedImage(null)}
        >
          <img 
            src={selectedImage} 
            alt="Enlarged view" 
            className="max-w-[95vw] max-h-[95vh] object-contain rounded-lg shadow-2xl cursor-default"
            onClick={(e) => e.stopPropagation()} 
          />
        </div>
      )}
    </div>
  );
};

export default MuruganTempleWebsite;
